// pages/NewsPage.tsx
import React, {useEffect, useState} from "react";
import {News} from "../models/News";
import {NewsService} from "../services/NewsService";
import {NewsCard} from "../components/NewsCard";
import "../styles/news.css";
import {useNavigate} from "react-router-dom";

const service = new NewsService();

const NewsPage: React.FC = () => {
    const [news, setNews] = useState<News[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        service
            .getAll()
            .then(setNews)
            .catch((e) => setError(e.message))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="news-page">
            <h1 className="news-title">Новости</h1>

            <div className="news-content">
                {loading && <div className="news-loading">
                  <div className="page_content">
                    <div className="spinner-wrapper" style={{ marginTop: 80 }}>
                      <div className="spinner"></div>
                    </div>
                  </div>
                </div>}
                {error && <div className="news-error">{error}</div>}

                <div className="news-grid">
                    {news.map((n) => (
                        <NewsCard
                            key={n.id}
                            news={n}
                            onOpen={(id) => navigate(`/news/${id}`)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NewsPage;
